export const activityEvents = [
  // {
  //   id: 249,
  //   name: "1st paid session booked",
  //   allowedStages: ["Pending Conversion"],
  // },
  // {
  //   id: 246,
  //   name: "1st paid session cancelled",
  //   allowedStages: ["Pending Conversion"],
  // },
  {
    id: 244,
    name: "1st paid session done",
    allowedStages: ["Pending Conversion"],
  },
  {
    id: 247,
    name: "1st paid session missed",
    allowedStages: ["Pending Conversion"],
  },
  // {
  //   id: 245,
  //   name: "1st paid session rescheduled",
  //   allowedStages: ["Pending Conversion"],
  // },
  {
    id: 208,
    name: "Asked for follow up",
    allowedStages: [
      "New Leads",
      "Bookings",
      "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  // {
  //   id: 209,
  //   name: "Asked for more info",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  // { id: 227, name: "Cancelled before the call", allowedStages: ["Bookings"] },
  // {
  //   id: 231,
  //   name: "Cancelled before the session",
  //   allowedStages: ["Consult Done"],
  // },
  // { id: 248, name: "Claim submitted", allowedStages: [] },
  // {
  //   id: 241,
  //   name: "Client accepts copay",
  //   allowedStages: ["Awaiting Insurance Info"],
  // },
  // {
  //   id: 240,
  //   name: "Client declines due to high copay",
  //   allowedStages: ["Awaiting Insurance Info"],
  // },
  // {
  //   id: 242,
  //   name: "Client needs time to think about copay",
  //   allowedStages: ["Awaiting Insurance Info"],
  // },
  // { id: 206, name: "Consult booking made", allowedStages: ["New Leads"] },
  {
    id: 223,
    name: "Consult done and first free session booked",
    allowedStages: ["Bookings"],
  },
  {
    id: 224,
    name: "Consult done and first free session not booked",
    allowedStages: ["Bookings"],
  },
  // {
  //   id: 225,
  //   name: "Declines the first free session",
  //   allowedStages: ["Consult Done"],
  // },
  // { id: 207, name: "Denied booking(not interested)", allowedStages: [] },
  // {
  //   id: 226,
  //   name: "Denied for the first free session",
  //   allowedStages: ["Consult Done"],
  // },
  // {
  //   id: 203,
  //   name: "Duplicate leads",
  //   allowedStages: ["New Leads", "Bookings"],
  // },
  // {
  //   id: 222,
  //   name: "Email sent",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  { id: 230, name: "First free session done", allowedStages: ["Consult Done"] },
  // {
  //   id: 237,
  //   name: "Insurance documents received",
  //   allowedStages: ["FFS Done"],
  // },
  // { id: 239, name: "Insurance verification failed", allowedStages: [] },
  // { id: 238, name: "Insurance verification success", allowedStages: [] },
  // { id: 234, name: "Interested in insurance", allowedStages: [] },
  // {
  //   id: 235,
  //   name: "Interested in OOP",
  //   allowedStages: ["Awaiting Insurance Info"],
  // },
  {
    id: 104,
    name: "Left a Voice Mail",
    allowedStages: [
      "New Leads",
      "Bookings",
      // "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  {
    id: 220,
    name: "Left a Voice Mail and SMS",
    allowedStages: [
      "New Leads",
      "Bookings",
      // "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  // { id: 229, name: "Missed the consult call", allowedStages: ["Bookings"] },
  { id: 233, name: "Missed the session", allowedStages: ["Consult Done"] },
  {
    id: 210,
    name: "No voice mail left (vm not configured/ vm full)",
    allowedStages: [
      "New Leads",
      "Bookings",
      // "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  // {
  //   id: 236,
  //   name: "Not interested",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  {
    id: 205,
    name: "Others (comments)",
    allowedStages: [
      "New Leads",
      "Bookings",
      "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  // { id: 251, name: "Request Stage Change to Junk", allowedStages: [] },
  // { id: 250, name: "Request Stage Change to Lost", allowedStages: [] },
  // { id: 228, name: "Rescheduled the call", allowedStages: ["Bookings"] },
  // { id: 232, name: "Rescheduled the session", allowedStages: ["Consult Done"] },
  // {
  //   id: 212,
  //   name: "Ringing and Hangup",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  {
    id: 218,
    name: "RnR - ringing not received & LVM",
    allowedStages: [
      "New Leads",
      "Bookings",
      // "Consult Done",
      "FFS Done",
      "Awaiting Insurance Info",
      "Insurance Verified",
      "Pending Conversion",
    ],
  },
  // {
  //   id: 243,
  //   name: "Simple Practice setup done",
  //   allowedStages: ["Insurance Verified"],
  // },
  // { id: 253, name: "SMS Received", allowedStages: [] },
  // { id: 252, name: "SMS Sent", allowedStages: [] },
  // {
  //   id: 221,
  //   name: "SMS Text sent",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  // {
  //   id: 204,
  //   name: "Testing leads",
  //   allowedStages: [
  //     "New Leads",
  //     "Bookings",
  //     "Consult Done",
  //     "FFS Done",
  //     "Awaiting Insurance Info",
  //     "Insurance Verified",
  //     "Pending Conversion",
  //   ],
  // },
  {
    id: 211,
    name: "Wrong number",
    allowedStages: ["New Leads", "Bookings"],
  },
  {
    id: 254,
    name: "Paid session done",
    allowedStages: ["Paid"],
  },
  {
    id: 255,
    name: "Paid session missed",
    allowedStages: ["Paid"],
  },
  {
    id: 262,
    name: "30 mins ffs successful",
    allowedStages: ["30 min FFS booked"],
  },
  {
    id: 263,
    name: "30 mins ffs missed",
    allowedStages: ["30 min FFS booked"],
  },
];

export const DISPOSITION_IDS_TO_NOT_SHOW = [
  267, 266, 265, 264, 260, 22, 3001, 3002, 2001, 0, 22, 21,
];
